import {Button, Table} from "antd";
import React from "react";
import WaitingShipmentTable from "../waitingShipmentTable/WaitingShipmentTable";
import {SearchOutlined} from "@ant-design/icons";
import {
    CloseIcon,
    SearchInput
} from "../../../_defaultComponents/FilterComponents/FilterComponentStyles";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
const WaitingTransferTable = ({
    parentRecord,
    selectedTransferKeys,
    setSelectedTransferKeys,
    setSelectedShipmentKeys,
    selectedShipmentKeys,
    barcodeStates,
    setBarcodeStates,
    transfersData,
    setPageParam
}) => {
    const transferRowSelection = {
        selectedRowKeys: selectedTransferKeys,
        preserveSelectedRowKeys: true,
        onChange: selectedKeys => {
            setSelectedTransferKeys(selectedKeys);

            const newSelectedShipmentKeys = [];
            selectedKeys.forEach(transferWithGroupId => {
                const [groupId, transferId] = transferWithGroupId.split("-");
                transfersData?.transfers.forEach(group => {
                    const transfer = group.transfers.find(t => t.transferId === transferId);
                    if (transfer) {
                        transfer.shipments.forEach(shipment => {
                            newSelectedShipmentKeys.push(
                                `${groupId}-${transfer.transferId}-${shipment._id}`
                            );
                        });
                    }
                });
            });

            setSelectedShipmentKeys(newSelectedShipmentKeys);
        }
    };

    return (
        <>
            <Table
                dataSource={parentRecord.transfers}
                pagination={false}
                rowKey={record => `${parentRecord.groupId}-${record.transferId}`}
                rowSelection={transferRowSelection}
                className="transfer-table"
                expandable={{
                    expandedRowRender: record => {
                        const barcodeText =
                            barcodeStates[`${parentRecord.groupId}-${record.transferId}`]?.text ||
                            "";
                        const barcodeNumber =
                            barcodeStates[`${parentRecord.groupId}-${record.transferId}`]?.number ||
                            "";

                        return (
                            <div style={{padding: "16px 0"}}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "16px",
                                        borderBottom: "1px solid #f0f0f0",
                                        paddingBottom: "16px"
                                    }}
                                >
                                    <b style={{marginRight: "16px"}}>Sevkiyat Detayları</b>
                                    <div style={{width: "300px"}}>
                                        <SearchInput
                                            placeholder="Barkod Numarası"
                                            value={barcodeText}
                                            data-testid="barcodeSearch"
                                            onSearch={value => {
                                                setPageParam(1);
                                                setBarcodeStates(prev => ({
                                                    ...prev,
                                                    [`${parentRecord.groupId}-${record.transferId}`]: {
                                                        ...prev[
                                                            `${parentRecord.groupId}-${record.transferId}`
                                                        ],
                                                        number: value,
                                                        text: value
                                                    }
                                                }));
                                            }}
                                            onChange={event => {
                                                const value = event.target.value;
                                                setBarcodeStates(prev => ({
                                                    ...prev,
                                                    [`${parentRecord.groupId}-${record.transferId}`]: {
                                                        ...prev[
                                                            `${parentRecord.groupId}-${record.transferId}`
                                                        ],
                                                        text: value
                                                    }
                                                }));
                                            }}
                                            enterButton={
                                                <CustomButton
                                                    data-testid="barcodeSearch_searchButton"
                                                    icon={<SearchOutlined />}
                                                />
                                            }
                                            suffix={
                                                barcodeText ? (
                                                    <CloseIcon
                                                        onClick={() => {
                                                            setPageParam(1);
                                                            setBarcodeStates(prev => ({
                                                                ...prev,
                                                                [`${parentRecord.groupId}-${record.transferId}`]: {
                                                                    text: "",
                                                                    number: ""
                                                                }
                                                            }));
                                                        }}
                                                    />
                                                ) : (
                                                    <span />
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                                <WaitingShipmentTable
                                    record={record}
                                    barcodeNumber={barcodeNumber}
                                    selectedShipmentKeys={selectedShipmentKeys}
                                    setSelectedShipmentKeys={setSelectedShipmentKeys}
                                    parentRecord={parentRecord}
                                />
                            </div>
                        );
                    }
                }}
            >
                <Table.Column
                    title="Transfer Adı"
                    dataIndex="transferName"
                    key="transferName"
                    width={"200px"}
                />
                <Table.Column
                    title="Kurye"
                    dataIndex="courier"
                    key="courier"
                    width={"200px"}
                    render={courier => <span>{courier?.fullname || "-"}</span>}
                />
                <Table.Column
                    title="Konum"
                    dataIndex="trackingUrl"
                    key="trackingUrl"
                    width={"200px"}
                    render={trackingUrl =>
                        trackingUrl?.url && (
                            <Button
                                type="ghost"
                                onClick={() => window.open(trackingUrl?.url, "_blank")}
                            >
                                Konumu Gör
                            </Button>
                        )
                    }
                />
            </Table>
        </>
    );
};

export default WaitingTransferTable;
